import { GREEN_500, getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  id: 'AirLinkListItemWidget',
  avatarIcon: 'RechargeIcon',
  title: 'title text',
  heading: 'heading',
  subHeading: 'sub heading',
  actionType: 'icon',
  actionTypeProps: {
    iconName: 'RightChevronIcon',
    iconAsAction: false,
    buttonText: 'BUTTON',
    text: '₹1999.00',
    infoTagType: 'default',
    infoTagText: 'Text Label'
  },
  actionTypeOnPress: e => console.log('actionTypeProps press', e),
  metaInfoTag: 'Text label',
  metaInfoText: 'subtext 2 here',
  metaInfoCta: 'button',
  metaInfoCtaPress: e => console.log('metaInfoCtaPress press', e),
  infoIconPress: () => console.log('infoIconPress press'),
  showTooltip: true,
  tooltipProps: {
    text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit!',
    autoHide: true
  },
  headingInfoTag: 'new',
  headingIconName: 'TickEnclosedFilledIcon',
  headingIconColor: GREEN_500,
  onPress: {
    id: 'this is onPress metaData'
  },
  actionTypeOnPressMetaData: {
    id: 'this is actionTypeOnPress metaData'
  },
  metaInfoCtaPressMetaData: {
    id: 'this is metaInfoCtaPress metaData'
  },
  onUserAction: e => console.log(e)
}, getTestId('LinkListItemWidgetContainer'));